const baseUrl = "/v1/admin/user";
const baseUrl2 = "/v1";

export const apiUrls = {
  list: `${baseUrl}`,
  create: `${baseUrl}/create`,
  update: (id: number): string => `${baseUrl}/${id}/update`,
  delete: (id: number): string => `${baseUrl}/${id}/delete`,
  details: (id: number): string => `${baseUrl}/${id}/details`,
  interestAssessmentDetails: (exam_id: number): string =>
    `${baseUrl}/${exam_id}/interest-assessment-detail`,
  skillAssessmentDetails: (exam_id: number): string =>
    `${baseUrl}/${exam_id}/skill-assessment-detail`,
  assessmentResultsDetails: (exam_id: number): string =>
    `${baseUrl}/${exam_id}/assessment-result`,
  pdfResultDetails: (id: number) => `${baseUrl}/${id}/download-result-pdf`,
  bulkUpdate: `${baseUrl}/bulk-update`,
  changeStatus: (id: number): string => `${baseUrl}/${id}/change-status`,
  invite: `${baseUrl}/invite`,
  verifyfile: `${baseUrl}/verify`,
  importfile: `${baseUrl}/import`,
  adminUserChangePassword: `${baseUrl}/user-change-password`,
  getEducationLevels: `${baseUrl2}/education-levels`,
  USER_RESET_EXAM: (user_id:any)=>`${baseUrl2}/reset-exam/${user_id}`,
  SetUserSpecialFlag: `/v1/update-flag`, //1 = exam flag , 2 = profile flag
  getUserIndustyExam:(user_id:any)=> `${baseUrl}/${user_id}/industry-exams`, //1 = exam flag , 2 = profile flag

};
